export default "__VITE_ASSET__K9VkEM9wROOizOg3VfnMIg__";